const customSelectors = {};
class customJS {
    constructor() {
      if (document.querySelector('[data-switch-tab]') != null) {
        document.querySelectorAll('[data-switch-tab] .tablink').forEach(function(target) {
          target.addEventListener("click", function(data) {
            document.querySelectorAll('[data-switch-tab] .tablink').forEach(function(inTarget) {
              inTarget.classList.remove('open');
            });
            data.currentTarget.classList.add('open');
          });
        });
      }

      if (document.querySelector('[data-months-switch]') != null) {
        document.querySelectorAll('[data-months-switch] input').forEach(function(target) {
          target.addEventListener("click", function(data) {
            var closestTarget = data.currentTarget.closest('.subscription-pack-wrapper')
            closestTarget.querySelectorAll('.cta-give-it').forEach(function(event) {
              event.classList.add('d-none');
            });
            if (data.currentTarget.value == '1') {
              closestTarget.querySelector('[data-3-month]').classList.remove('d-none');
            } else if (data.currentTarget.value == '2') {
              closestTarget.querySelector('[data-6-month]').classList.remove('d-none');
            } else {
              closestTarget.querySelector('[data-12-month]').classList.remove('d-none');
            }
          });
        });
      }
    }
}

typeof customJS !== 'undefined' && new customJS();
